"use strict"

import React from "react"

import VerticalDashedLine from "./VerticalDashedLine"
import { withGraphState } from "../../../config/GraphConfigProvider"

function CriticalActionsLayer({
  x,
  y,
  actions,
  show_critical_actions, // From withGraphState
}) {
  const crit_markers = actions.filter((a) => a.priority === "CRIT")
  if (!show_critical_actions) return <></>
  return <VerticalDashedLine x={x} y={y} arr={crit_markers} color={"var(--lanzalake-red)"} />
}

export default withGraphState(CriticalActionsLayer)
